(function($) {

    function sidebarOpen(){
        $('html').addClass('overflow_hidden');
        $(".nav").addClass("nav-bg");
        $(".search__sidebar").addClass("search__sidebar--opened");
        setTimeout(() => {
            $('body').addClass('search-overlay ')
        }, 1)
    }

    function sidebarClose(){
        $(".search__sidebar").removeClass("search__sidebar--opened");
        $('body').removeClass('search-overlay');
        $(".search").removeClass("nav-bg");
        $('html').removeClass('overflow_hidden');
    }


    // Close modal on body overlay click
    $(document).on("click", "body.search-overlay .body-content", function (e) {
        sidebarClose()
    })

    // Close modal on Escape
    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            sidebarClose()
        }
    });

    $(".search__sidebar-opener").on("click", function () {
        if(!$(this).hasClass('search__sidebar-opener--opened')){
            sidebarOpen();
        }
    })

    $(".search__sidebar_reset").on("click", function () {
        if($(this).closest('.search__sidebar').hasClass('search__sidebar--opened')){
            sidebarClose();
        }
    })


})(jQuery);